module.exports = __webpack_public_path__ + "static/img/partner10.6e68139.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partner10.png
// module id = Y7kY
// module chunks = 1